import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../context/Auth/Create'
import Cookies from 'js-cookie'
import { PermissionsWithUrl } from '../helpers/permission';
export const useLogin=()=>{
const userAuth=useAuthContext();
const navigate=useNavigate()
const login=(data)=>{
Cookies.set(`${process.env.NODE_ENV}-userToken`,data.token,{expires:1,path:"/"});
localStorage.setItem(`${process.env.NODE_ENV}-user`,JSON.stringify(data.user));
userAuth.updateState(data.user)
window.$("#root").addClass("app");
navigate("/dashboard")
}
return [login];

}
